// extracted by mini-css-extract-plugin
module.exports = {"error-boundary-comp-wrapper":"iX9M6azY","error-boundary-container":"KE_di_Qa","title":"c3VyILbP","error-info":"J5Xoky2S","refresh-button":"QlFZCl__"};